const delay = 5 * 1000;
const delayLimit = 3 * 60 * 1000;

const parameters = {
   method: 'POST',
   mode: 'cors',
   cache: 'no-cache',
   headers: {
      'Content-Type': 'application/json'
   },
   body: ''
};

export { calculate, getPaymentData };

async function fetchWithRetry(url, parameters) {
   let timeout;
   return new Promise(resolve => {
      (function check(retries = 0) {
         fetch(url, parameters)
            .then(response => {
               switch(response.status) {
                  case 200:
                     resolve(response.json());
                     break;
                  case 204:
                     if (retries * delay < delayLimit) {
                        clearTimeout(timeout);
                        timeout = setTimeout(() => check(++retries), delay);
                        break;
                     } // falls through
                  default:
                     resolve(null);
               }
            });
      })();
   });
}

async function calculate(id, year) {
   return fetchWithRetry('/api/calculate', { ...parameters, body: JSON.stringify({ id, year }) });
}

async function getPaymentData(id, year, subscription) {
   return fetchWithRetry('/api/payment', { 
      ...parameters, 
      body: JSON.stringify({ id, year, subscription }) 
   });
}
